import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

// components
import { onHoldLabel } from '../messages/pdpPriceMessages';

// styles
import styles from './PdpSharedSidebarPrice.scss';

const holds = {
    ON_HOLD: 'pdp-on-hold',
    ON_HOLD_CUSTOM: 'pdp-on-hold-for-you',
};

const expiresMessage = <FormattedMessage id="pdp.PdpSharedHold.expires" defaultMessage="Expires" />;

export function Hold({ holdType, holdDisplayTime }) {
    const showExpiration = holds[holdType] === holds.ON_HOLD_CUSTOM && holdDisplayTime;
    if (holds[holdType]) {
        return (
            <div className={styles.hold} data-tn={holds[holdType]}>
                {onHoldLabel(holdType)}
                {showExpiration && (
                    <div className={styles.countdown}>
                        {expiresMessage} {holdDisplayTime}
                    </div>
                )}
            </div>
        );
    } else {
        return null;
    }
}

Hold.propTypes = {
    holdType: PropTypes.oneOf(['ON_HOLD', 'ON_HOLD_CUSTOM']),
    holdDisplayTime: PropTypes.string,
};

export default Hold;
